import { Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

/**
 * @typedef {object} Props
 * @prop {any} error
 */
/**
 * @param {Props} props
 */
function FormErrorMessage({ error, ...otherProps }) {
  return (
    <Text
      fontSize="0.875rem"
      colorPalette="red"
      color="colorPalette.fg"
      {...otherProps}
    >
      {(error?.message?.length ?? 0) > 0 && error?.message}

      {error?.type === "required" && (
        <FormattedMessage defaultMessage="Champ requis" />
      )}
    </Text>
  );
}

export default FormErrorMessage;
